import styled from "styled-components";
import { AppPageHeader } from "components/AppPageHeader";
import { PidgeToggle } from "components/AppHeader/PidgeToggle";
import { useDocumentTitle } from "hooks/usePageTitle";

const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const PidgePage = () => {
  useDocumentTitle("Pidge");

  return (
    <PageWrapper>
      <AppPageHeader title="Pidge" />
      <PidgeToggle />
    </PageWrapper>
  );
};
